import { gql } from "apollo-boost";

export const FEATURED_DISHES = gql`
  query featuredDishes($dishCount: Int) {
    featuredDishes(dishCount: $dishCount) {
      id
      chefId
      name
      slug
      description
      media {
        url
        type
        appType
        size
      }
      cuisines
      dishTypes
      isDraft
      ingredients
      minPrice
      chefName
      minDinerSize
      equipmentNeeded
      approxIngredientsCost
      numOfLikes
    }
  }
`;

export const CUISINES = gql`
  query cuisines($country: String!) {
    cuisines(country: $country)
  }
`;

export const FIND_DISHES = gql`
  query findDishes(
    $filters: Filters!
    $cursor: String
    $pageSize: Int
    $includeChefs: Boolean!
  ) {
    findDishes(
      filters: $filters
      cursor: $cursor
      pageSize: $pageSize
      includeChefs: $includeChefs
    ) {
      dishes {
        id
        name
        description
        slug
        media {
          url
          type
          appType
          size
        }
        chefName
        cuisines
        dishTypes
        isDraft
        ingredients
        minPrice
        minDinerSize
        equipmentNeeded
        numOfLikes
      }
      endCursor
      hasMore
    }
  }
`;

export const DISHES_BY_CHEF = gql`
  query dishesByChef(
    $chefId: ID!
    $live: Boolean
    $cursor: String
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    dishesByChef(
      chefId: $chefId
      live: $live
      cursor: $cursor
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      dishes {
        id
        chefId
        name
        slug
        description
        media {
          url
          type
          size
          appType
        }
        cuisines
        dishTypes
        isDraft
        ingredients
        minPrice
        minDinerSize
        equipmentNeeded
        numOfLikes
        approxPrepTime
      }
      next
      previous
      hasNext
      hasPrevious
    }
  }
`;

export const GET_DISH = gql`
  query dish($id: ID!, $live: Boolean) {
    dish(id: $id, live: $live) {
      id
      chefId
      name
      description
      media {
        url
        type
        size
        appType
      }
      cuisines
      dishTypes
      slug
      isDraft
      ingredients
      minPrice
      minDinerSize
      equipmentNeeded
      numOfLikes
      liked
      saved
      approxPrepTime
    }
  }
`;

export const GET_DISH_BY_SLUG = gql`
  query getDishesBySlug($slug: String!) {
    getDishesBySlug(slug: $slug) {
      id
      chefId
      name
      description
      media {
        url
        type
        size
        appType
      }
      cuisines
      dishTypes
      slug
      isDraft
      ingredients
      minPrice
      minDinerSize
      equipmentNeeded
      numOfLikes
      liked
      saved
      approxPrepTime
    }
  }
`;
